/* Product specifications (snippets/product-specs.liquid).
   - "Se alle specifikationer" opens the specs drawer. Its body is a copy of the Detaljer table, made on first open, so
     the page carries the table once (for Google and AI) and the drawer needs no second render.
   - A badge (product-badges.liquid) opens its explainer text.
   - An ingredient with its own page (metaobject web page) opens it in the ingredient drawer. */
(() => {
  if (window.productSpecsReady) return;
  window.productSpecsReady = true;

  // Detaljer's badge row is a copy of the one in "Kort fortalt" (rendered once, product-specs.liquid).
  const copyBadges = () =>
    document.querySelectorAll("[data-badges-slot]:empty").forEach((slot) => {
      // The gift sets carry one badge row per set (product-badges.liquid): copy them all, so the swap works there too.
      // The product's own: not the free gift's in the cart drawer (cart-gift-info), which comes earlier in the page.
      const own = (selector) => [...document.querySelectorAll(selector)].find((el) => !el.closest(".cart-gift-info"));
      const source = own("[data-badges-sets]") || own("[data-badges]");
      if (source) slot.replaceWith(source.cloneNode(true));
    });
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", copyBadges);
  else copyBadges();

  // An ingredient pointed at or touched starts loading, so the drawer opens on it at once.
  if (window.ec) window.ec.prefetchWithin(document, "[data-ingredient-url]", (el) => [el.dataset.ingredientUrl, "main-ingredient"]);

  document.addEventListener("click", (event) => {
    const opener = event.target.closest("[data-specs-open]");
    if (opener) {
      const drawer = document.getElementById("pdp-specs");
      const body = drawer && drawer.querySelector("[data-specs-drawer-body]");
      const table = document.querySelector("[data-dropdown-topic='features'] .specs--full");
      if (!drawer || !body || !table) return;
      // The drawer sits inside the Om produktet tab, whose height animation would clip it: move it to <body> once.
      if (drawer.parentElement !== document.body) document.body.appendChild(drawer);
      if (!body.firstElementChild) body.appendChild(table.cloneNode(true));
      body.scrollTop = 0;
      drawer.openDrawer();
      return;
    }

    // An ingredient with its own page opens it in the ingredient drawer: the page's section, fetched (section rendering).
    const ingredient = event.target.closest("[data-ingredient-url]");
    if (ingredient) {
      const drawer = document.getElementById("pdp-ingredient");
      if (!drawer) return;
      event.preventDefault();
      if (drawer.parentElement !== document.body) document.body.appendChild(drawer);
      const url = ingredient.dataset.ingredientUrl;
      const body = drawer.querySelector("[data-ingredient-drawer-body]");
      drawer.querySelector("[data-ingredient-drawer-title]").textContent = ingredient.dataset.ingredientName;
      drawer.querySelector("[data-ingredient-drawer-link]").href = url;
      body.replaceChildren();
      body.setAttribute("aria-busy", "true");
      drawer.openDrawer();
      // Only the latest request may fill the drawer (a slow earlier one must not replace it or redirect).
      const seq = (drawer.ingredientSeq = (drawer.ingredientSeq || 0) + 1);
      const current = () => seq === drawer.ingredientSeq;
      Promise.all([window.ec.sectionFetch(url, "main-ingredient"), drawer.dataset.ingredientCss ? window.ec.loadStyle(drawer.dataset.ingredientCss).catch(() => {}) : null])
        .then(([html]) => {
          if (!current()) return;
          const article = new DOMParser().parseFromString(html, "text/html").querySelector("[data-ingredient]");
          if (article) body.replaceChildren(article);
        })
        .catch(() => {
          if (current()) window.location.href = url;
        })
        .finally(() => {
          if (current()) body.removeAttribute("aria-busy");
        });
      return;
    }

    // An ingredient's source number opens the collapsed "Om studierne og kilderne" and goes to that source. Focus goes
    // along (the source is focusable, tabindex -1), so Tab carries on from there and a screen reader reads it; on the
    // ingredient's own page the address gets its #kilde-N without a jump (not in the product page's drawer, where a
    // reload would find no such source). No smooth scroll for a visitor who asked for reduced motion.
    const cite = event.target.closest(".ingredient__cite a");
    if (cite) {
      const article = cite.closest("[data-ingredient]");
      const hash = cite.getAttribute("href");
      const target = article && article.querySelector(hash);
      const dropdown = target && target.closest("wdn-dropdown");
      if (target) {
        event.preventDefault();
        if (dropdown && !dropdown.isActive && dropdown.setActive) dropdown.setActive();
        const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        setTimeout(() => {
          target.scrollIntoView({ behavior: reduced ? "auto" : "smooth", block: "center" });
          target.focus({ preventScroll: true });
          if (!cite.closest("#pdp-ingredient") && window.location.hash !== hash) history.replaceState(history.state, "", hash);
        }, 350);
      }
      return;
    }

    // A badge opens its explainer under the badge row; one open at a time, a second tap closes it.
    const badge = event.target.closest("[data-badge]");
    if (badge) {
      const scope = badge.closest("[data-badges]");
      const open = badge.getAttribute("aria-expanded") !== "true";
      scope.querySelectorAll("[data-badge]").forEach((b) => b.setAttribute("aria-expanded", "false"));
      scope.querySelectorAll("[data-badge-panel]").forEach((panel) => {
        panel.hidden = !(open && panel.dataset.badgePanel === badge.dataset.badge);
      });
      if (open) badge.setAttribute("aria-expanded", "true");
      // In "Om produktet" the dropdown fixed its height when it opened, so the explainer was cut off: release it.
      const container = scope.closest(".dropdown-container");
      if (container) container.style.height = "initial";
      return;
    }

  });
})();
